import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import {
  LoadRolesSuccess,
  LoadRolesFailed,
  RolesActionTypes,
} from './roles.actions';
import { RolesService } from '@roles/services/roles.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RolesEffects {
  @Effect()
  loadRoles$ = this.actions$.pipe(
    ofType(RolesActionTypes.LOAD_ROLES),
    switchMap(() =>
      forkJoin([
        this.rolesService.getRolesPermissions(),
        this.rolesService.getUserRoles(),
      ]).pipe(
        map(
          ([rolesPermissions, roles]) =>
            new LoadRolesSuccess({ rolesPermissions, roles }),
        ),
        catchError(() => {
          this.toastr.error('Could not fetch roles', 'Request failed');
          return of(new LoadRolesFailed());
        }),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private rolesService: RolesService,
    private toastr: ToastrService,
  ) {}
}
